module.exports = __webpack_public_path__ + "img/ee.0d4a8bc2.svg";